import { Container, Reveal } from '@/components/common'
import heroBg from '@/assets/images/IBON-World-Launch-27.jpeg'

export const MagazineHero = () => {
  return (
    <section className="relative isolate overflow-hidden bg-ibon-dark">
      <div
        className="absolute inset-0 -z-20 bg-cover bg-center"
        style={{ backgroundImage: `url(${heroBg})` }}
        aria-hidden
      />
      <div className="absolute inset-0 -z-10 bg-ibon-dark/85" />
      <div className="absolute inset-0 -z-10 bg-linear-to-b from-ibon-dark/60 via-transparent to-ibon-dark" />

      <Container className="py-28 lg:py-40">
        <Reveal variant="up" delay={100}>
          <h1 className="mt-8 max-w-5xl text-4xl font-bold leading-[1.03] tracking-[-0.02em] text-white sm:text-5xl lg:text-7xl">
            Stories, insights &amp;{' '}
            <span className="text-white/40">ideas that inspire change.</span>
          </h1>
        </Reveal>

        <Reveal variant="up" delay={220}>
          <p className="mt-9 max-w-3xl text-lg leading-relaxed text-white/75">
            Our platform for sharing the stories, perspectives, and innovations shaping the future
            of Africa and the Caribbean. We celebrate{' '}
            <span className="font-semibold text-white">
              entrepreneurship, culture, leadership, and the people
            </span>{' '}
            driving positive change through articles, interviews, success stories, and expert
            insights.
          </p>
        </Reveal>
      </Container>
    </section>
  )
}
